import * as React from "react";
import { Redirect, Route } from "react-router-dom";
import { useHasSomePermissions, useHasSomeGlobalPermissions } from "../misc/components/Authorization";

export const PrivateRoute = ({ permissions, children, ...rest }) => {
    const valid = useHasSomePermissions(permissions);
    return (
        <Route
            {...rest}
            render={({ location }) =>
                valid ? (
                    children
                ) : (
                    <Redirect
                        to={{
                            pathname: "/unauthorized",
                            state: { from: location }
                        }}
                    />
                )
            }
        />
    );
}

export const PrivateRouteAllStudies = ({ permissions, children, ...rest }) => {
    const valid = useHasSomeGlobalPermissions(permissions);
    return (
        <Route
            {...rest}
            render={({ location }) =>
                valid ? (
                    children
                ) : (
                    <Redirect
                        to={{
                            pathname: "/unauthorized",
                            state: { from: location }
                        }}
                    />
                )
            }
        />
    );
}
